import HumanizerAddress from './HumanizerAddress'

export default HumanizerAddress
